<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="alert alert-info">
          <strong>Info:</strong> Les actions à exécuter pour le virement P2P sur Lemonway :<br><br>
          <div v-for="actions in transferTypeInfo.actions">
            <strong>Actions: {{ actions.action }}; Montant: {{ actions.amount | formatDecimalPrice }} €</strong>
          </div>
        </div>
        <div class="m-t" v-if="resultForSaleRdvDocuments.length > 0">
          <div class="bg-muted p-xs b-r-sm document document-green">
            <div class="row">
              <div class="col-lg-3 document-title">
                <span>Visualiser le certificat d'immatriculation</span>
              </div>
              <div class="col-lg-3 document-title">
                <button
                    v-for="document in resultForSaleRdvDocuments"
                    @click="fetchDocument(document.carRegistration.id)"
                    class="btn btn-default btn-circle"
                    v-tooltip.top-center="'Visualiser'"
                >
                  <i class="fa fa-eye"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="m-t" v-else>
          <div class="bg-muted p-xs b-r-sm document document-red">
            <div class="row">
              <div class="col-lg-3 document-title">
                <span>Veuillez déposer le certificat d'immatriculation dans documents</span>
              </div>
              <div class="col-lg-3 document-title">
                <router-link :to="{ name: 'command-details-documents' }">
                  <button
                      class="btn btn-default btn-circle"
                      v-tooltip.top-center="'Déposer le document'"
                  >
                    <i class="fa fa-plus"></i>
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
        <table class="table table-striped" v-if="transferHistory.transfers">
          <thead>
            <tr>
              <th>Date</th>
              <th>User</th>
              <th>Action</th>
              <th>Status</th>
              <th></th>
              <th>Commentaire</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="list in transferHistory.transfers" v-if="list.type !== 4 && list.type !== 3">
              <td>
                {{ list.date }}
              </td>
              <td>
                {{ list["user"] }}
              </td>
              <td>
                {{ list["action"] }}
              </td>
              <td class="btn-lmd">
                <button v-if="list['status'] === 1" type="button" class="btn btn-w-m btn-primary"><i class="fa fa-check"></i><span class="bold">Complet</span> </button>
                <button v-else type="button" class="btn btn-w-m btn-danger"><i class="fa fa-times"></i><span class="bold">Exécution a échoué</span> </button>
              </td>
              <td>
                <button v-if="list['status'] !== 1" type="button" class="btn btn-w-m btn-info" @click="onReload(list['amount'], list['action'])"><i class="fa fa fa-repeat"></i><span class="bold">Relancer</span></button>
              </td>
              <td>
                <p class="small">
                  {{ list["comment"] }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="col-lg-12">
          <button v-if="paymentControllInfo.status === true" type="button"
                  class="btn btn-w-m btn-primary pull-right btn-svt" @click="$parent.toggleBlock(3)">Suivant</button>
          <button v-else type="button"
                  class="btn btn-w-m btn-primary pull-right" @click="onSubmit">Executer virements P2P</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import TransferHistoryList from '../../../api/query/TransferHistoryList.gql'

export default {
  props: {
    orderId: {
      type: String,
    },
    customerId: {
      type: String,
    },
    paymentMode: {
      type: Number,
    },
    status: {
      type: [String, Number,Object],
      default: ""
    }
  },
  data: () => ({
    transferHistory: [],
    newPrice: "",
    errorMessage: null,
    timer: 1000,
    hiddenElements: {
      fast: true,
      secure: true,
      care: true
    },
    reloadWallet: false,
    isValid: false,
    paymentControllInfo: {
      status: "",
    },
    transferTypeInfo: {
      actions: []
    },
    action: {
      type: String,
      default: ""
    },
    amount: {
      type: String,
      default: ""
    },
    resultForSaleRdvDocuments: []
  }),
  computed: {
    transfertMoneyToCarizyMutation () {
      return gql`
          mutation {
            transfertMoneyToCarizy(orderId: ${this.orderId}, amount: ${this.amount}, type: "${this.action}")
            {
              date
              user
              action
              comment
              status
              amount
              walletSeller
              walletBuyer
              transferType
            }
          }`
    },
    executeTransferMutation () {
      return gql`
          mutation {
            executeTransfer(orderId: ${this.orderId})
            {
              transfers{
                  date
                  user
                  action
                  comment
                  status
                  amount
                  walletSeller
                  walletBuyer
                  transferType
                }
            }
          }`
    },
    display() {
      return (element) => {
        return !this.hiddenElements[element]
      }
    },
    setPaymentControlMutation () {
      return gql`
          mutation {
            setPaymentControl(orderId: ${this.orderId})
            {
              status
            }
          }`
    },
  },
  async created () {
    await this.getPaymentControlQuery()
    await this.getTransferTypeQuery()
    await this.fetchSaleRdvDocuments()
  },
  methods: {
    async fetchDocument (id) {
      try {
        var response = await this.getBase64Document(id);
        var base64 = response.data.showDocument.files[0].base64;

        this.showFileViewer({
          image: base64
        })
      } catch (e) {
        this.showBanner('danger', 'Le document associé n\'a  pu être récupéré.');
      }
    },
    async getBase64Document (id) {
      const query = gql`
          query {
            showDocument(
            files: {
              fileId: ${id}
            })
            {
              files {
                base64
                id
              }
            }
          }`

      return this.$apollo.query({
        query: query
      })
    },
    async getPaymentControlQuery () {
      const PaymentControlInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getPaymentControl (orderId: ${this.orderId}) {
                        status
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.paymentControllInfo.status = PaymentControlInfo.data.getPaymentControl.status

    },
    async getTransferTypeQuery () {
      const TransferType = await this.$apollo.query({
        query: gql`
                    query {
                     getTransferType (orderId: ${this.orderId}) {
                         actions {
                              action,
                              amount
                          }
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.transferTypeInfo.actions = TransferType.data.getTransferType.actions

    },
    async fetchSaleRdvDocuments() {
      const resultForSaleRdvDocuments = await this.$apollo.query({
        query: gql`
              query {
               projectDocument(orderId: "${this.orderId}") {
                    carRegistration {
                      id
                      valid
                    }
               }
              }
            `,
        fetchPolicy: 'no-cache'
      })
      this.resultForSaleRdvDocuments = resultForSaleRdvDocuments.data.projectDocument
    },
    displayElement(element) {
      this.hiddenElements[element] = false
    },
    getAction(action) {
      this.action = action
      return this.action
    },
    getAmount(amount) {
      this.amount = amount
      return this.amount
    },
    async onReload (amount, action) {
      this.getAmount(amount)
      this.getAction(action)
      this.$apollo.mutate({
        mutation: this.transfertMoneyToCarizyMutation
      }).then(() => {
        this.showBanner('success', `Succès: le virement ${action} est terminé`)
      }, () => {
        this.showBanner('danger', `le virement ${action} externe à échoué`)
      })
    },
    async onSubmit () {
      let result = await this.$validator.validateAll()
      if (result) {
        this.$apollo.mutate({
          mutation: this.executeTransferMutation
        }).then(() => {
          this.showBanner('success', `Succès: le virement p2p terminé`)
          if (this.paymentMode === 3) this.$router.push({name: 'command-details-virement-lemonway-b'})
          else this.$router.push({name: 'command-details-lemonway-b'})
          //this.$parent.toggleBlock(3)
          //location.reload(true)
        })
      }
    },
  },
  apollo: {
    transferHistory: {
      query: TransferHistoryList,
      variables () {
        return {
          orderId: this.orderId
        }
      },
    }
  }
}
</script>
